import ProtectedRouteContainer from './ProtectedRouteContainer'

export default ProtectedRouteContainer;